import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LoadingButton from '../../common/LoadingButton';
import { getTokenAndFetchHeaders } from '../../utils';
import { apiRequest } from '../../utils/authConfig';
import { useMsal, account } from '../../utils/authContext';
const api = process.env['REACT_APP_BACKEND_URL'];
const apiKey = process.env.REACT_APP_BACKEND_KEY ? process.env.REACT_APP_BACKEND_KEY : '';

type SendRRDRequestProps = {
    chapter: string,
    email: string,
};

export const SendRRDRequest = ({ chapter, email }: SendRRDRequestProps) => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { getToken } = useMsal();
    const args = { ...apiRequest, account };
    const handleChapterRequest = async () => {
        let error = false;
        let result: any | undefined;
        setLoading(true);
        try {
            const headers = await getTokenAndFetchHeaders(getToken, args, apiKey);
            const body = {
                chapterId: chapter,
                email: email,
            }
            const res = await fetch(`${api}/report/request/rrdmaillist`, {
                headers,
                method: 'POST',
                body: JSON.stringify(body),
            });
            if (!res.ok) {
                error = true;
                result = {
                    error: {
                        code: 'serverError',
                        message: 'There was an error processing your request.',
                    }
                };
            } else {
                result = await res.json();
                if (result?.error) {
                    error = true;
                }
            }
            navigate(`/print/?status=${result?.message ? result.message : result?.error?.message}${error ? "&error=true" : ''}`);
        } catch (err: any) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }
    return <>
        <LoadingButton loading={loading} disabled={!chapter || !email} onClick={handleChapterRequest}>Get List {chapter && `for ${chapter}`}</LoadingButton>
    </>
}